import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from '../../admin/app';
import FormModal from '../../common/components/FormModal';
import Button from '../../common/components/Button';
import extractText from '../../common/utils/extractText';
import ItemList from '../../common/utils/ItemList';
import Stream from '../../common/utils/Stream';
import Switch from '../../common/components/Switch';
import { generateRandomString } from '../../common/utils/string';
import Form from '../../common/components/Form';
export default class CreateUserModal extends FormModal {
  constructor() {
    super(...arguments);
    /**
     * The value of the username input.
     */
    _defineProperty(this, "username", void 0);
    /**
     * The value of the email input.
     */
    _defineProperty(this, "email", void 0);
    /**
     * The value of the password input.
     */
    _defineProperty(this, "password", void 0);
    /**
     * Whether email confirmation is required after signing in.
     */
    _defineProperty(this, "requireEmailConfirmation", void 0);
    /**
     * Keeps the modal open after the user is created to facilitate creating
     * multiple users at once.
     */
    _defineProperty(this, "bulkAdd", void 0);
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.username = Stream('');
    this.email = Stream('');
    this.password = Stream('');
    this.requireEmailConfirmation = Stream(false);
    this.bulkAdd = Stream(false);
  }
  className() {
    return 'Modal--small CreateUserModal';
  }
  title() {
    return app.translator.trans('core.admin.create_user.title');
  }
  content() {
    return m('[', null, m("div", {
      className: "Modal-body"
    }, this.body()));
  }
  body() {
    return m('[', null, m(Form, {
      className: "Form--centered"
    }, this.fields().toArray()));
  }
  fields() {
    const items = new ItemList();
    const usernameLabel = extractText(app.translator.trans('core.admin.create_user.username_placeholder'));
    const emailLabel = extractText(app.translator.trans('core.admin.create_user.email_placeholder'));
    const emailConfirmationLabel = extractText(app.translator.trans('core.admin.create_user.email_confirmed_label'));
    const useRandomPasswordLabel = extractText(app.translator.trans('core.admin.create_user.use_random_password'));
    const passwordLabel = extractText(app.translator.trans('core.admin.create_user.password_placeholder'));
    items.add('username', m("div", {
      className: "Form-group"
    }, m("input", {
      className: "FormControl",
      name: "username",
      type: "text",
      placeholder: usernameLabel,
      "aria-label": usernameLabel,
      bidi: this.username,
      disabled: this.loading
    })), 100);
    items.add('email', m("div", {
      className: "Form-group"
    }, m("input", {
      className: "FormControl",
      name: "email",
      type: "email",
      placeholder: emailLabel,
      "aria-label": emailLabel,
      bidi: this.email,
      disabled: this.loading
    })), 80);
    items.add('password', m("div", {
      className: "Form-group"
    }, m("input", {
      className: "FormControl",
      name: "password",
      type: "password",
      autocomplete: "new-password",
      placeholder: passwordLabel,
      "aria-label": passwordLabel,
      bidi: this.password,
      disabled: this.loading || this.password() === null
    })), 60);
    items.add('emailConfirmation', m("div", {
      className: "Form-group"
    }, m(Switch, {
      name: "emailConfirmed",
      state: this.requireEmailConfirmation(),
      onchange: checked => this.requireEmailConfirmation(checked),
      disabled: this.loading
    }, emailConfirmationLabel)), 40);
    items.add('useRandomPassword', m("div", {
      className: "Form-group"
    }, m(Switch, {
      name: "useRandomPassword",
      state: this.password() === null,
      onchange: enabled => {
        this.password(enabled ? null : '');
      },
      disabled: this.loading
    }, useRandomPasswordLabel)), 20);
    items.add('submit', m("div", {
      className: "Form-group"
    }, m(Button, {
      className: "Button Button--primary Button--block",
      type: "submit",
      loading: this.loading
    }, app.translator.trans('core.admin.create_user.submit_button'))), 0);
    items.add('submitAndAdd', m("div", {
      className: "Form-group"
    }, m(Button, {
      className: "Button Button--block",
      onclick: () => this.bulkAdd(true) && this.onsubmit(),
      disabled: this.loading
    }, app.translator.trans('core.admin.create_user.submit_and_create_another_button'))), -20);
    return items;
  }
  onready() {
    this.$('[name=username]').trigger('select');
  }
  onsubmit(e) {
    var _e;
    if (e === void 0) {
      e = null;
    }
    (_e = e) == null || _e.preventDefault();
    this.loading = true;
    app.store.createRecord('users', {}).save(this.submitData(), {
      errorHandler: this.onerror.bind(this)
    }).then(() => {
      if (this.bulkAdd()) {
        this.resetData();
      } else {
        this.hide();
      }
      this.alertAttrs = null;
    }).finally(() => {
      this.bulkAdd(false);
      this.loaded();
    });
  }

  /**
   * Get the data that should be submitted in the sign-up request.
   */
  submitData() {
    var _this$password;
    const data = {
      username: this.username(),
      email: this.email(),
      isEmailConfirmed: !this.requireEmailConfirmation(),
      password: (_this$password = this.password()) != null ? _this$password : generateRandomString(32)
    };
    return data;
  }
  resetData() {
    this.username('');
    this.email('');
    this.password('');
  }
}
flarum.reg.add('core', 'admin/components/CreateUserModal', CreateUserModal);